import React from "react";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "../../../components/CustomButtons/Button";
import ModalHeader from "../../../components/ModalHeader";

const TERMS_OF_USE_PATH = "/extras/terms-of-use";

export default function DataPrivacyModal({
  open,
  onClose,
  classes,
  Transition,
}) {
  const { t } = useTranslation();

  const base = "modeling_inputs_v3.data_privacy";
  const types = t(`${base}.types`, { returnObjects: true }) || [];
  const beforeItems = t(`${base}.before`, { returnObjects: true }) || [];
  const obsItems = t(`${base}.obs`, { returnObjects: true }) || [];

  return (
    <Dialog
      classes={{
        root: classes.modalRoot,
        paper: classes.modal,
      }}
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      aria-labelledby="data-privacy-modal-title"
      aria-describedby="data-privacy-modal-description"
      fullWidth
      maxWidth={"md"}
    >
      <ModalHeader
        id="data-privacy-modal-title"
        title={t(`${base}.title`)}
        onClose={onClose}
        closeLabel={t("common.close")}
      />
      <DialogContent
        id="data-privacy-modal-description"
        className={classes.modalBody}
      >
        <div
          style={{
            backgroundColor: "#FFF8E1",
            border: "1px solid #FFE082",
            borderRadius: 6,
            padding: "12px 14px",
            marginBottom: 18,
            fontSize: 13,
            lineHeight: 1.5,
            color: "#5D4037",
            fontWeight: 600,
          }}
        >
          {t(`${base}.highlight_before`)}
          <a
            href={TERMS_OF_USE_PATH}
            style={{ textDecoration: "underline", color: "inherit" }}
          >
            {t(`${base}.highlight_link`)}
          </a>
          {t(`${base}.highlight_after`)}
        </div>

        <h4 style={{ fontWeight: 700, fontSize: 15, margin: "0 0 8px" }}>
          {t(`${base}.q_heading`)}
        </h4>
        <p style={{ fontSize: 13, lineHeight: 1.5, margin: "0 0 8px" }}>
          <Trans
            i18nKey={`${base}.intro`}
            components={{ 1: <strong />, 2: <u /> }}
          />
        </p>
        <ul
          style={{
            fontSize: 13,
            lineHeight: 1.6,
            margin: "0 0 16px",
            paddingLeft: 22,
          }}
        >
          {types.map((item, idx) => (
            <li key={idx}>
              <strong>{item.label}</strong>
              {item.text}
            </li>
          ))}
        </ul>

        <h4 style={{ fontWeight: 700, fontSize: 15, margin: "0 0 8px" }}>
          {t(`${base}.before_heading`)}
        </h4>
        <ul
          style={{
            fontSize: 13,
            lineHeight: 1.6,
            margin: "0 0 16px",
            paddingLeft: 22,
          }}
        >
          {beforeItems.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <p style={{ fontSize: 13, lineHeight: 1.5, margin: "0 0 16px" }}>
          <Trans
            i18nKey={`${base}.remember`}
            components={{ 1: <strong />, 2: <strong />, 3: <u /> }}
          />
        </p>

        <h4 style={{ fontWeight: 700, fontSize: 15, margin: "0 0 8px" }}>
          {t(`${base}.obs_heading`)}
        </h4>
        <ul
          style={{ fontSize: 13, lineHeight: 1.6, margin: 0, paddingLeft: 22 }}
        >
          {obsItems.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button onClick={onClose} color="danger" simple>
          {t("common.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DataPrivacyModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  Transition: PropTypes.any,
};
